import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { NewRdoDialog } from "@/features/rdo/components/new-rdo-dialog";
import { RdoList, RdoListSkeleton } from "@/features/rdo/components/rdo-list";
import { useActiveObra } from "@/features/stages/hooks/use-active-obra.ts";
import { usePermissions } from "@/hooks/use-permissions.ts";

export function RdoListPage() {
	const { has, isLoading: permsLoading } = usePermissions();
	const {
		obra,
		isLoading: obraLoading,
		isError: obraError,
		refetch: refetchObra,
	} = useActiveObra();

	const canCreate = has("rdos:create");

	function body() {
		if (obraError) {
			return (
				<Card>
					<CardContent className="card-state">
						<p>Não foi possível carregar a obra.</p>
						<Button variant="outline" onClick={() => refetchObra()}>
							Tentar novamente
						</Button>
					</CardContent>
				</Card>
			);
		}
		if (permsLoading || obraLoading || !obra) {
			return <RdoListSkeleton />;
		}
		return <RdoList constructionId={obra.id} />;
	}

	return (
		<div className="rdo-page">
			<div className="page-header">
				<div>
					<h1 className="page-title">Relatório de Obra</h1>
					<p className="page-subtitle">
						Relatórios diários de obra prontos para o contratante.
					</p>
				</div>
				<div className="page-header__actions">
					{obra && canCreate && <NewRdoDialog constructionId={obra.id} />}
				</div>
			</div>

			{body()}
		</div>
	);
}
